import { render, staticRenderFns } from "./VTableBody.vue?vue&type=template&id=79f145be"
import script from "./VTableBody.vue?vue&type=script&lang=js"
export * from "./VTableBody.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports